import { render, staticRenderFns } from "./InsightsWhite.vue?vue&type=template&id=6f981ca3&scoped=true"
import script from "./InsightsWhite.vue?vue&type=script&lang=ts"
export * from "./InsightsWhite.vue?vue&type=script&lang=ts"
import style0 from "./InsightsWhite.vue?vue&type=style&index=0&id=6f981ca3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f981ca3",
  null
  
)

export default component.exports